import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import logoImg from '../../assets/logo.svg'; 

const StyledLogo = styled.div`
  font-size: ${props => props.theme.fontxxxl};
  transition: all 0.2s ease;
  display: flex;
  align-items: center;

  &:hover {
    transform: scale(1.1);
  }

  img {
    width: 100%;  // Adjust this width based on the desired logo size
    max-width: 150px;  // Example maximum width
  }

  @media (max-width: 64em) {
    font-size: ${props => props.theme.fontxxl};
  }
  @media (max-width: 30em) {
    font-size: ${props => props.theme.fontxl};
  }
`;

function Logo() {
  return (
    <StyledLogo>
      <Link to="https://www.airedify.in/">
        <img src={logoImg} alt="Airedify Logo" /> 
      </Link>
    </StyledLogo>
  );
}

export default Logo;
